<mat-toolbar class="p-0 mat-elevation-z1">
  <div class="fx-fill fxf-auto-fill-r fxl-row fxla-start-center">
    <div class="fxf-1-0-auto-r fxl-row fxla-start-center">
      @if (!hiddenNavbar && !rightNavbar) {
        <button (click)="toggleSidebarOpen('navbar')" class="icon-button-fix-alignment navbar-toggle-button" mat-icon-button>
          <mat-icon class="secondary-text">menu</mat-icon>
        </button>
      }
      @if (!hiddenNavbar && !rightNavbar) {
        <div class="toolbar-separator fx-hide_gt-md"></div>
      }
      @if (horizontalNavbar) {
        <div class="fxl-row fxla-start-center">
          <div class="logo ml-16">
            <img class="logo-icon" src="assets/images/logos/fuse.svg" />
          </div>
        </div>
      }

      <div class="px-8 px-md-16">
        <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
      </div>
    </div>

    @if (!hiddenNavbar && !rightNavbar) {
      <div class="toolbar-separator fx-hide_gt-md"></div>
    }

    <div class="fxf-0-1-auto-r fxl-row fxla-start-center">
      <button [matMenuTriggerFor]="helpMenu" class="help-button" mat-button>
        <div class="fxl-row fxla-center-center">
          <mat-icon class="s-20 secondary-text">info</mat-icon>
          <span class="username ml-12 mr-12 fx-hide fx-show-block_gt-sm">Aide</span>
          <mat-icon class="secondary-text s-16 fx-hide_xs">keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #helpMenu="matMenu" [overlapTrigger]="false" class="help-menu">
        @for (helpLink of helpLinks; track helpLink.url) {
          @if (helpLink.topSeparatorFlag) {
            <div class="horizontal-toolbar-separator"></div>
          }
          @if (helpLink.url) {
            <a class="help-menu-item" href="{{ helpLink.url }}" mat-menu-item target="_blank">
              @if (helpLink.icon.startsWith('svg')) {
                <mat-icon class="secondary-text s-20" svgIcon="{{ helpLink.icon }}"></mat-icon>
              } @else {
                <mat-icon class="secondary-text s-20">{{ helpLink.icon }}</mat-icon>
              }
              {{ helpLink.label }}
            </a>
          }
          @if (helpLink.action) {
            <a (click)="$any(helpLink).action()" [disabled]="$any(helpLink).isDisabledAction()" class="help-menu-item" mat-menu-item>
              @if (helpLink.icon.startsWith('svg')) {
                <mat-icon class="secondary-text s-20" svgIcon="{{ helpLink.icon }}"></mat-icon>
              } @else {
                <mat-icon class="secondary-text s-20">{{ helpLink.icon }}</mat-icon>
              }
              {{ helpLink.label }}
            </a>
          }
        }
      </mat-menu>

      <div class="toolbar-separator"></div>

      <button [matMenuTriggerFor]="userMenu" class="user-button" data-testid="user-menu-button" mat-button>
        <div class="fxl-row fxla-center-center">
          <mat-icon class="s-20 secondary-text">tune</mat-icon>
          <span class="username ml-12 mr-12 fx-hide fx-show-block_gt-sm" id="username">{{ username }}</span>
          <mat-icon class="secondary-text s-16 fx-hide_xs">keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button (click)="myAccount()" data-testid="my-account-button" mat-menu-item>
          <mat-icon class="secondary-text s-20" svgIcon="svg_user"></mat-icon>
          <span class="toolbar-menu-item">{{ 'TOOLBAR.MY_ACCOUNT' | translate }}</span>
        </button>

        <div class="horizontal-toolbar-separator"></div>

        @if (multiConnexionFlag) {
          <button mat-menu-item>
            <mat-icon class="secondary-text s-20" svgIcon="svg_theme"></mat-icon>
            <span class="toolbar-menu-item">{{ 'TOOLBAR.ACCOUNT_AREA' | translate }}</span>
          </button>
        }
        @if (multiConnexionFlag) {
          <div class="ml-12">
            <app-area-selector></app-area-selector>
          </div>
        }
        @if (customerAreaFlag || (laboratoryAreaFlag && applicationSettingsFlag)) {
          <button (click)="applicationSettings()" data-testid="application-settings-button" mat-menu-item>
            <mat-icon class="secondary-text s-20" svgIcon="svg_settings"></mat-icon>
            <span class="toolbar-menu-item">{{ 'TOOLBAR.APPLICATION_SETTINGS' | translate }}</span>
          </button>
        }
        @if (laboratoryAreaFlag && userManagementFlag) {
          <button (click)="userManagement()" data-testid="user-management-button" mat-menu-item>
            <mat-icon class="secondary-text s-20" svgIcon="svg_user_management"></mat-icon>
            <span class="toolbar-menu-item">{{ 'TOOLBAR.USER_MANAGEMENT' | translate }}</span>
          </button>
        }
        @if (laboratoryAreaFlag && apiCredentialSettingsFlag) {
          <button (click)="navigateToApiCredentials()" data-testid="api-credentials-button" mat-menu-item>
            <mat-icon class="secondary-text s-20" svgIcon="svg_api_key"></mat-icon>
            <span class="toolbar-menu-item">{{ 'TOOLBAR.API_CREDENTIALS' | translate }}</span>
          </button>
        }
        @if (
          multiConnexionFlag ||
          customerAreaFlag ||
          (laboratoryAreaFlag && applicationSettingsFlag) ||
          (laboratoryAreaFlag && userManagementFlag) ||
          (laboratoryAreaFlag && apiCredentialSettingsFlag)
        ) {
          <div class="horizontal-toolbar-separator"></div>
        }

        <button mat-menu-item>
          <mat-icon class="secondary-text s-20" svgIcon="svg_theme"></mat-icon>
          <span class="toolbar-menu-item">{{ 'TOOLBAR.COLOR_THEMES_TITLE' | translate }}</span>
        </button>

        <div class="ml-12">
          <app-theme-selector></app-theme-selector>
        </div>

        <div class="horizontal-toolbar-separator"></div>

        <button (click)="logout()" class="" data-testid="logout-button" mat-menu-item>
          <mat-icon class="secondary-text s-20">exit_to_app</mat-icon>
          <span class="toolbar-menu-item">{{ 'TOOLBAR.LOGOUT' | translate }}</span>
        </button>
      </mat-menu>

      <div class="toolbar-separator"></div>

      <button [matMenuTriggerFor]="languageMenu" class="language-button fx-hide fx-show-block_gt-xs" mat-button>
        @if (selectedLanguage) {
          <div class="fxl-row fxla-center-center">
            <img [src]="'assets/icons/flags/' + selectedLanguage.flag + '.png'" class="flag mr-8" />
            <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
          </div>
        }
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        @for (lang of languages; track lang.id) {
          <button (click)="setLanguage(lang)" mat-menu-item>
            <span class="fxl-row fxla-start-center">
              <img [src]="'assets/icons/flags/' + lang.flag + '.png'" class="flag mr-16" />
              <span class="iso">{{ lang.title }}</span>
            </span>
          </button>
        }
      </mat-menu>

      <div class="toolbar-separator fx-hide fx-show-block_gt-xs"></div>

      <button
        (click)="toggleSidebarOpen('rightSidebar')"
        class="right-sidebar-panel-toggle-button mat-badge"
        mat-button
        matBadge="{{ unreadNotificationNumber && unreadNotificationNumber > 0 ? unreadNotificationNumber : '' }}"
        matBadgeColor="accent"
        matBadgeSize="small"
      >
        @if (notificationNumber && notificationNumber > 0) {
          <mat-icon class="accent-fg s-20" svgIcon="svg_notifications_active"></mat-icon>
        }
        @if (!notificationNumber || (notificationNumber && notificationNumber === 0)) {
          <mat-icon class="s-20 secondary-text">notifications</mat-icon>
        }
      </button>

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator fx-hide fx-show-block_gt-xs"></div>
      }
      @if (!hiddenNavbar && rightNavbar) {
        <button (click)="toggleSidebarOpen('navbar')" class="icon-button-fix-alignment navbar-toggle-button" mat-icon-button>
          <mat-icon class="secondary-text">menu</mat-icon>
        </button>
      }
    </div>
  </div>
</mat-toolbar>
